import { RootState } from "redux/store";
import { useAppSelector } from "redux/hooks";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PriceGroupsStoresSearchFilterQuery } from "models/filters/priceGroupsStores/PriceGroupsStoresSearchFilterQuery";
import { PriceGroupsStoreApi } from "apis/PriceGroupsStoreApi";
import { PriceGroupsStoreAddUpdate, PriceGroupsStoreView } from "models/dbModels/priceGroups/PriceGroupsStore";
import { PriceGroupsStoresBulkUpdate } from "models/filters/priceGroupsPricing/PriceGroupsStoresBulkUpdate";
import { PriceGroup } from "models/dbModels/priceGroups/PriceGroup";


export const getPriceGroupsStore = createAsyncThunk("assignPriceGroupSlice/getPriceGroupsStore", async (params: PriceGroupsStoresSearchFilterQuery) => {
    params = { ...params, offset: params.offset || 0, limit: params.limit || 100, };
    const response = await PriceGroupsStoreApi.Search(params);
    return response.data;
});

export const getPriceGroupsStoreSimple = createAsyncThunk("assignPriceGroupSlice/getPriceGroupsStoreSimple", async (params: PriceGroupsStoresSearchFilterQuery) => {
    params = { ...params, offset: params.offset || 0, limit: params.limit || 100, };
    const response = await PriceGroupsStoreApi.Search(params);
    return response.data;
});

export function GetCurrentPriceGroup(priceGroupId: number) {
    const priceGroups = useAppSelector((state: RootState) => state.priceGroups);
    const priceGroup: any = priceGroups.table.find((priceGroup: any) => priceGroup.id === priceGroupId);
    return priceGroup ? priceGroup.name : "Base Sell Price";
}

export const modifyPriceGroupsStore = createAsyncThunk("assignPriceGroupSlice/modifyPriceGroupsStore", async (params: PriceGroupsStoreAddUpdate[]) => {
    const response = await PriceGroupsStoreApi.Modify(params);
    return response.data;
});


export const bulkUpdatePriceGroupsStore = createAsyncThunk("assignPriceGroupSlice/bulkUpdatePriceGroupsStore", async (params: PriceGroupsStoresBulkUpdate) => {
    const response = await PriceGroupsStoreApi.BulkUpdate(params);
    return response.data;
});

export const applyPriceGroupsStore = createAsyncThunk("assignPriceGroupSlice/applyPriceGroupsStore", async (params: PriceGroupsStoresSearchFilterQuery) => {
    const response = await PriceGroupsStoreApi.Apply(params);
    return response.data;
});


export type InitialStateType = PriceGroup & {
    stores: PriceGroupsStoreView[];
    activeTab: number;
    currentStore: number;
    currentStorePriceGroup: string;
    selectedStores: { position: number, id: number }[][];
    departments: any[];
    currentDepartment: number;
    managedStockGroupId: number;
    currentSubDepartment: number;
    currentDepartmentPriceGroup: string;
    selecetedDepartments: { position: number, id: number }[][];
    stocks: PriceGroupsStoreView[];
    selectedStocks: { position: number, id: number }[][];
    deselectedStocks: { position: number, id: number }[][];
    departmentIdFilter: number;
    subdepartmentIdFilter: number;
    loading: boolean;
    keyword: string;
    totalRows: number;
    totalPages: number;
    pageIndex: number;
    pageSize: number;
    selectAllFilter: boolean;
    error: string
};

const initialState: InitialStateType = {
    id: 0,
    name: "",
    stores: [],
    activeTab: 1,
    currentStore: 0,
    currentStorePriceGroup: "",
    selectedStores: [],
    departments: [],
    currentDepartment: 0,
    managedStockGroupId: 0,
    currentSubDepartment: 0,
    currentDepartmentPriceGroup: "",
    selecetedDepartments: [],
    stocks: [],
    selectedStocks: [],
    deselectedStocks: [],
    departmentIdFilter: 0,
    subdepartmentIdFilter: 0,
    loading: false,
    keyword: "",
    totalRows: 0,
    totalPages: 0,
    pageIndex: 0,
    pageSize: 100,
    selectAllFilter: false,
    error: ""
};

const assignPriceGroupsSlice = createSlice({
    name: "assignPriceGroupSlice",
    initialState: {
        ...initialState,
    },
    reducers: {
        cleanAssignPriceGroup: (state) => {
            return {
                ...state,
                ...initialState,
            };
        },
        updateAssignPriceGroupField: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        },
        addSelectedRows: (state, action) => {
            // @ts-ignore
            state.selectedStocks[action.payload.index] = action.payload.rows;
        },
        addDeselectedRows: (state, action) => {
            // @ts-ignore
            state.deselectedStocks[action.payload.index] = action.payload.rows;
        },
        updateAssignPriceGroupTableField: (state, action) => {
            const { field, index, key, value } = action.payload;
            // @ts-ignore
            state[field][index][key] = value;
        },
        addAGGridSelectedStores: (state, action) => {
            return {
                ...state,
                selectedStores: action.payload
            };
        },
        addAGGridSelectedDepartments: (state, action) => {
            return {
                ...state,
                selectedDepartments: action.payload
            };
        },
        addAGGridSelectedStock: (state, action) => {
            return {
                ...state,
                selectedStocks: action.payload
            };
        },
        addAGGridDeselectedStock: (state, action) => {
            return {
                ...state,
                deselectedStocks: action.payload
            };
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getPriceGroupsStore.pending, (state, action) => {
            const groupBy = action.meta.arg.groupBy;
            if (groupBy === "Stores") {
                state.stores = [];
                state.loading = true;
            }
            if (groupBy === "Departments") {
                state.departments = [];
                state.loading = true;
            }
            if (groupBy === "None") {
                state.stocks = [];
                state.loading = true;
            }
        });
        builder.addCase(getPriceGroupsStore.fulfilled, (state, action) => {
            const groupBy = action.meta.arg.groupBy;
            if (groupBy === "Stores") {
                state.stores = action.payload.data;
            }
            if (groupBy === "Departments") {
                // state.departments = [];
            }
            if (groupBy === "None") {
                const stocks = action.payload.data.sort((a:any, b:any) => a.managedStockName.localeCompare(b.managedStockName));
                state.stocks = stocks ? stocks.map((stock: any) => { return { ...stock, id: stock.managedStockId } })   : [];
                state.totalRows = action.payload.totalRows;
                state.totalPages = Math.ceil(Math.ceil(action.payload.totalRows) / state.pageSize);
            }
            state.loading = false;
        });
    },
});

export const {
    addAGGridSelectedStores,
    addAGGridSelectedDepartments,  
    addSelectedRows,
    addDeselectedRows,
    cleanAssignPriceGroup,
    updateAssignPriceGroupField,
    updateAssignPriceGroupTableField,
    addAGGridSelectedStock,
} = assignPriceGroupsSlice.actions;

export default assignPriceGroupsSlice.reducer;
